// /middleware/auth.ts
export default defineNuxtRouteMiddleware((to) => {
  const { isAuth, goToSignin } = useAuth()

  // If the user is NOT authenticated – kick them to the login page
  if (!isAuth()) {
    return goToSignin(to.fullPath)
  }
})